export enum DurationType {
  SEC = 'SEC',
  MIN = 'MIN',
}
